import React, { useEffect, useState } from "react";

interface Props {
  value: number | string | null | undefined;
  disabled?: boolean;
  type?: "number" | "text";
  placeholder?: string;
  hasError?: boolean;
  onCommit: (value: string) => unknown;
}

/**
 * A lightweight, uncontrolled-while-typing input.
 * The value is buffered locally so typing feels instant even inside a
 * large spreadsheet, and is only committed (dispatched) on blur / Enter -
 * mirroring how the previous cell-edit-grid only committed on exiting a cell.
 */
export const EditableCell = ({
  value,
  disabled = false,
  type = "text",
  placeholder,
  hasError = false,
  onCommit,
}: Props) => {
  const toText = (val: typeof value) =>
    val === null || val === undefined ? "" : String(val);

  const [localValue, setLocalValue] = useState(toText(value));

  useEffect(() => {
    setLocalValue(toText(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <input
      className={`rs-cell-input${hasError ? " rs-cell-error" : ""}`}
      type={type}
      inputMode={type === "number" ? "decimal" : undefined}
      value={localValue}
      disabled={disabled}
      placeholder={placeholder}
      onChange={(event) => setLocalValue(event.target.value)}
      onBlur={() => onCommit(localValue)}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          (event.target as HTMLInputElement).blur();
        }
      }}
    />
  );
};
